import BlogTableOfContents from "./BlogTableOfContents";

const BlogTableOfContentsWithProps = ({ blok }) => {
  return <BlogTableOfContents items={blok.items} />;
};

export default BlogTableOfContentsWithProps;
